import styled from 'styled-components'


export const FooterWrapper = styled.section`
    height:100px;
    color:white;
    margin:0px 80px;
    border-top:1px solid white;
    display:flex;
    align-items:center;
    padding-bottom:60px;

    @media(max-width: 800px) {
        display:flex;
        flex-direction:column;
        width:400px;
        margin-bottom:50px;
        padding-bottom:150px;
       
      }
`

export const FooterLeft = styled.div`
margin-top:20px;
display:flex;
justify-content:space-between;
width:45%;
align-items:center;

h4 {
    margin-left:30px;
}

@media(max-width: 800px) {
    display:flex;
    flex-direction:column;
    width:400px;


  }
`

export const FooterRight = styled.div`
display:flex;
flex:1;
align-items:center;
padding-top:4px;
justify-content:flex-end;
`

export const ImgIcon = styled.img`
width:24px;
height:24px;
margin-left:12px;
`